import { ReactNode } from 'react';
import { config } from '../../utils/config';

export const getLinksForTranslation = () =>
  Object.fromEntries(
    config.links.map(({ key, link }) => [
      `${key}Link`,
      (chunk: ReactNode) => (
        <Link path={config.features.appDeepLinkRewrites.enabled && config.origin === 'app' ? 'app://' + key : link}>
          {chunk}
        </Link>
      ),
    ])
  );

type LinkProps = {
  children: ReactNode;
  path: string;
  target?: string;
  rel?: string;
  className?: string;
};

const Link = ({ children, path, target = '_blank', rel = 'noopener noreferrer', className }: LinkProps) => (
  <a
    target={target}
    rel={rel}
    href={path}
    className={className}
    onClick={
      !IS_WEB_COMPONENT
        ? undefined
        : e => {
            e.preventDefault();
            window.open(path, target);
          }
    }
  >
    {children}
  </a>
);

export default Link;
